module.exports = __webpack_public_path__ + "static/media/DSC_0073.7c01f15c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0073.jpg
// module id = 687
// module chunks = 0